import { Center, Flex, Text, Image } from '@chakra-ui/react'

import MathleticsLogoImage from './assets/MathleticsLogo.svg'
import { ErrorContent, type ErrorContentProps } from './ErrorContent'
import { SystemStyleObject } from '@chakra-ui/styled-system'

export type ErrorPageProps =
  & ErrorContentProps
  & {
  headerRightText?: string | null
  backgroundStyles?: SystemStyleObject
}

/**
 * Figma Design
 * https://www.figma.com/file/af9kkSa6gGOPbmy3xG1geE/Student-Centre-for-DEV?type=design&node-id=5608-301975&mode=design&t=FDsyWd9nQHmocsNy-0
 */
export function ErrorPage({
  headerRightText = null,
  backgroundStyles,
  ...restProps
}: ErrorPageProps) {
  return (
    <Flex w={'100%'} direction={'column'} h={'100vh'} sx={backgroundStyles}>
      <Flex w={'100%'} justify={'space-between'}>
        <Image
          src={MathleticsLogoImage}
          pt={'46px'}
          px={'37px'}
        />

        {headerRightText && <Text
          color={'neutral.800'}
          fontSize={'24px'}
          p={'32px'}
        >
          {headerRightText}
        </Text>}
      </Flex>

      <Center w={'100%'}>
        <ErrorContent
          px={'20px'}
          py={'20px'}
          justify={'center'}
          {...restProps}
        />
      </Center>
    </Flex>
  )
}
